<template>
    <div class="topAppNav_box">
      <el-popover
        :trigger="sence == 'default' ? 'click' : 'hover'"
        :show-arrow="false"
        ref="topAppNav_popper"
        :placement="sence == 'default' ? 'bottom' :'right'"
        :popper-class="'topAppNav_popper'"
        :width="600"
        @before-enter="queryAppsByGroup"
      >
        <template #reference>
            <slot name="iconSlot">
                <i class="iconfont icon-caidan-tianchong" style="font-size: 18px;line-height: 20px; color: #fff;">         
                </i>
            </slot>
        </template>
        <div class="topAppNav_list">
                <div class="defalutIndex_content_appHeaderBox">
                    <div class="defalutIndex_content_appHeader_text">
                        <img src="@img/flow/workbentch/appIcon.png">
                        自建应用
                    </div>
                    <div class="defalutIndex_content_appHeader_input">
                        <i class="iconfont icon-sousuo1"></i>
                        <el-input v-model="searchVal" placeholder="搜索应用名称" />
                    </div>
                    <div class="defalutIndex_content_appHeader_op">
                        <div class="defalutIndex_content_appHeader_add" @click="openDragFlag">
                            <i class="iconfont icon-setting"></i>
                            星标应用导航
                        </div>
                    </div>
                </div>
                <div class="defalutIndex_content_appList">
                    <div class="defalutIndex_content_appGroup" v-if="starList.length!=0">
                        <div class="defalutIndex_content_appGroup_title" v-if="starList.some(ele =>{
                            return ele.sapp_name.includes(searchVal)
                        }) ">
                            星标自建应用
                        </div>
                        <div class="defalutIndex_content_appGroup_items">
                            <div class="defalutIndex_content_appGroup_item" @click="linkToDetailFunc(appItem)" v-for="appItem,appIndex of starList.filter((xitem)=>{
                                    return (xitem?.sapp_name??'').includes(searchVal)
                                })" :key="appIndex">
                                <div class="defalutIndex_content_appGroup_itemBox">
                                    <div class="defalutIndex_content_appGroup_itemIcon">
                                        <img :src="appItem.sapp_icon" style="width: 100%;height: 100%;object-fit: contain;border-radius:6px;"/>
                                    </div>
                                </div>
                                <div class="defalutIndex_content_appGroup_itemNmae">
                                    {{appItem.sapp_name}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="defalutIndex_content_appGroup">
                        <div class="defalutIndex_content_appGroup_title" v-if="appList.some(ele =>{
                            return ele.sapp_name.includes(searchVal)
                        }) || (appList.length==0 && !searchVal)">
                            全部自建应用
                        </div>
                        <div class="defalutIndex_content_appGroup_items">
                            <div class="defalutIndex_content_appGroup_item" @click="linkToDetailFunc(appItem)" v-for="appItem,appIndex of appList.filter((xitem)=>{
                                    return xitem.sapp_name.includes(searchVal)
                                })" :key="appIndex">
                                <div class="defalutIndex_content_appGroup_itemBox">
                                    <div class="defalutIndex_content_appGroup_itemIcon">
                                        <img :src="appItem.sapp_icon" style="width: 100%;height: 100%;object-fit: contain;border-radius:6px;"/>
                                    </div>
                                </div>
                                <div class="defalutIndex_content_appGroup_itemNmae">
                                    {{appItem.sapp_name}}
                                </div>
                            </div>
                        </div>
                        <div class="defalutIndex_empty" v-if="appList.length==0 && !searchVal">
                            暂无应用
                        </div>
                    </div>
                </div>
        </div>
      </el-popover>
    <el-dialog
        v-model="cstAppConfig.flag"
        title="星标应用"
        width="440px"
        center
        top="5vh"
        :close-on-click-modal="false"
      >
        <div class="dlg_main">
            <div class="cstAppContent_box">
                <div class="cstAppContent_item" 
                    v-for="item,index of cstAppConfig.starApps" :key="index"
                    :draggable="true"
                    @dragstart="dragstart(item)"
                    @dragover="dragover($event,item)"
                    :class="item.sapp_id == dragConfig.endAppId.sapp_id?('dragItem_'+dragConfig.pos):''"
                >
                    <div class="cstAppContent_header">
                        <div><i class="iconfont icon-Union"></i></div>
                        <div class="cstAppContent_header">
                            <div class="cstAppContent_icon">
                                <img v-if="item.sapp_icon" :src="item.sapp_icon" style="width: 100%;height: 100%;object-fit: contain;border-radius:4px;"/>
                                <i   v-else class="iconfont icon-setting"></i>
                            </div>
                            <div class="cstAppContent_name">{{ item.sapp_name }}</div>
                        </div>
                    </div>
                    <div @click="delItem(item)">
                        <i class="iconfont icon-shanchu1"></i>
                    </div>
                </div>
                <div class="cstAppContent_add" v-if="cstAppConfig.starApps.length < 8" @click="appSelector.flag = true">
                    <i class="iconfont icon-jiahao"></i>
                    新增星标应用
                </div>
            </div>
        </div>
    </el-dialog>
    <el-dialog
        v-model="appSelector.flag"
        title="自建应用选择器"
        width="350px"
        center
        top="5vh"
        :close-on-click-modal="false"
      >
        <div class="dlg_main">
            <div class="appSelect_input">
                <el-input v-model="appSelector.appName" placeholder="搜索应用名称" />
            </div>
            <div class="appSelect_box">
                <div class="appSelect_group">
                    <div style="margin-bottom: 8px;padding: 0 15px;" v-if="appList.some(ele =>{
                            return ele.sapp_name.includes(appSelector.appName)
                        }) || (appList.length==0&&!appSelector.appName)">
                       全部自建应用
                    </div>
                    <div >
                        <div class="appSelect_item" 
                            v-for="item,index of appList.filter((xitem)=>{
                                return xitem.sapp_name.includes(appSelector.appName)
                            })" :key="index"
                            @click="selectApp(item)"
                        >
                            <div class="appSelect_header">
                                <div class="appSelect_header">
                                    <div class="appSelect_icon">
                                        <img :src="item.sapp_icon" style="width: 100%;height: 100%;object-fit: contain;border-radius:6px;"/>
                                    </div>
                                    <div class="appSelect_name">{{ item.sapp_name }}</div>
                                </div>
                            </div>
                            <div class="appSelect_empty" v-if="appList.length==0&&!appSelector.appName">
                                暂无应用
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </el-dialog>
    <el-dialog
        title="应用跳转"
        v-model="isSelfBuildAppJump"
        width="350px"
        top="30vh"
        center
        :close-on-click-modal="false"
        @close="closeDialogInfo5()"
      >
        <div class="selfBuildApp_middle_head1">
            <span>你即将在新窗口打开<br>“{{this.name}}”应用</span>
        </div>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closeDialogInfo5()" round>取消</el-button>
                <el-button type="primary" @click="openNewWindow()" round>打开应用</el-button>                    
            </span>
        </template>
    </el-dialog>
    <!-- <el-drawer
        title="自建应用授权"
        v-model="isSelfBuildAppInit"
        size="height:60%;width:25%;"
        direction="btt"
        :show-close="false"
        :close-on-click-modal="false"
        @close="closeDialogInfo6"
      >
        <div class="selfBuildApp_middle_head">
            <span>你即将进入“{{this.name}}”应用，为了您能正常使用，需要以下授权</span>
        </div>
        <div class="selfBuildApp_after_appAuth">
            <div class="selfBuildApp_auth">
                <span>                    
                    <div class="selfBuildApp_icon">
                        <i class="iconfont icon-dianhua" style="font-size: 26px;line-height: 40px;"></i>
                    </div>
                    “手机”权限授予
                </span>
            </div>
            <div class="selfBuildApp_auth">
                <span>
                    <div class="selfBuildApp_icon">
                        <i class="iconfont icon-geren" style="font-size: 26px;line-height: 40px;"></i>
                    </div>
                    “个人信息”权限授予
                </span>
            </div>
        </div>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closeDialogInfo6" round>取消</el-button>
                <el-button type="primary" @click="saveDialogInfo6" round>进入应用</el-button>                    
            </span>
        </template>
      </el-drawer> -->
    </div>
</template>
  
<script>
  export default {
    props: {
      sence: {
        type: String,
        default: function () {
            return 'default';
        },
      }
    },
    data() {
      return {
        searchVal:'',
        appList: [ ],
        starList: [ ],
        cstAppConfig:{
            flag:false,
            deletingItemId:null,
            starApps:[],
        },
        dragConfig:{
            starAppId:null, 
            endAppId:{
                
            }, 
            pos:null
        },
        appSelector:{
            flag:false,
            appName:'',
            
        },
        appAuth:{
            phone:false,
            empInfo:false
        },
        //权限对话框需要的信息
        id:null,
        index:null,
        key:null,
        name:null,
        // isSelfBuildAppInit:false,
        isSelfBuildAppJump:false,
      }
    },
    mounted() {
        
    },
    methods: {
        queryAppsByGroup(){
            this.appList = []
            this.starList = []
            this.$http.post(this.$api.selfApp.querySelfAppList, 
            {}).then(res => {
                this.appList= res.payload
            })
            this.$http.post(this.$api.selfApp.queryStarSelfAppList,
            {}).then(res => {
                if(res.payload) {
                    this.starList=res.payload || []
                }
            })
        },
        linkToDetailFunc(item) {
            this.$http.post(this.$api.selfApp.querySelfAppDtl, {
                sapp_id:item.sapp_id
            }).then(res => {
                if(res.payload){
                    if(!(res.payload.sapp_key==null||res.payload.sapp_key==''||
                        res.payload.sapp_index==null||res.payload.sapp_index==''||
                        res.payload.sapp_name==null||res.payload.sapp_name==''
                    )){
                        if(res.payload.sapp_status==0){
                            this.$message.warning('应用未启用，请先启用应用')
                        }else{
                            if(this.$refs['topAppNav_popper']){
                                this.$refs['topAppNav_popper'].hide()
                            }
                            if(res.payload.sapp_jumpMode!=null&&res.payload.sapp_jumpMode==0){
                                this.$router.push({
                                    path:'/selfBuildApp/selfBuildLogin',
                                    query:{
                                        sapp_id:res.payload.sapp_id,
                                        sapp_key:res.payload.sapp_key,
                                        sapp_index:res.payload.sapp_index,
                                        sapp_name:res.payload.sapp_name,
                                    }
                                })
                            }else if(res.payload.sapp_jumpMode!=null&&res.payload.sapp_jumpMode==1){
                                    this.id=res.payload.sapp_id
                                    this.index=res.payload.sapp_index
                                    this.key=res.payload.sapp_key
                                    this.name=res.payload.sapp_name
                                    this.openDialogFunc5()
                            }else if(res.payload.sapp_jumpMode!=null&&res.payload.sapp_jumpMode==2){
                                    if(this.isElectronNonWxWork()){
                                        const { shell } = require('electron');
                                        shell.openExternal(res.payload.sapp_index);
                                    }
                                    else{
                                        window.open(res.payload.sapp_index,'_blank')
                                    }
                            }else{
                                this.$message.error('应用状态异常，请联系管理员设置')//这个状态不是很严谨
                            }     
                        }
                    }else{
                        this.$message.error('应用配置不全无法跳转')
                    }
                }
            })
        },
        isElectronNonWxWork() {
            const ua = navigator.userAgent.toLowerCase();
            return ua.includes('electron/') && !ua.includes('wxwork');
            // return true
        },
        isValidUrl(url){
            try {
                new URL(url);
                return true;
            } catch {
                return false;
            }
        },
        openDragFlag() {
            if(this.$refs['topAppNav_popper']){
                this.$refs['topAppNav_popper'].hide()
            }
            this.$http.post(this.$api.selfApp.queryStarSelfAppList, {
            }).then(res => {
                if(res.payload) {
                    this.cstAppConfig.starApps = res.payload || []
                }
                this.cstAppConfig.flag = true
            })
        },
        dragstart(item){
            this.dragConfig.starAppId = {...item}
            document.addEventListener("dragend",this.dragend)
        },
        dragover(e,item){
            e.preventDefault();
            this.dragConfig.endAppId = {...item}
            this.dragConfig.pos = e.offsetY < (e.target.clientHeight/2) ? 'top':'bottom'
        },
        dragend(){
            document.removeEventListener("dragend",this.dragend)
            if(!this.dragConfig.starAppId.sapp_id || !this.dragConfig.endAppId.sapp_id){
                this.dragConfig ={
                    starAppId:null,
                    endAppId:{},
                    pos:null,
                }
                return
            }
            if(this.dragConfig.starAppId.sapp_id == this.dragConfig.endAppId.sapp_id){
                this.dragConfig ={
                    starAppId:null,
                    endAppId:{},
                    pos:null,
                }
                return
            }
            let olArr = [
                {
                    ...this.dragConfig.starAppId,
                },
                {
                    ...this.dragConfig.endAppId,
                },
            ]
            if(this.dragConfig.pos == 'bottom'){
                olArr.reverse();
            }
            let newArr = this.cstAppConfig.starApps.filter(zitem=>{return zitem.sapp_id != this.dragConfig.starAppId.sapp_id})
            let seq = 0
            let resArr = newArr.reduce((res = [],item)=>{
                if(item.sapp_id == this.dragConfig.endAppId.sapp_id){
                    let obj1 = {
                        ...olArr[0],
                        ssa_seq:seq
                    }
                    seq++
                    res.push(obj1)
                    let obj2 = {
                        ...olArr[1],
                        ssa_seq:seq
                    }
                    seq++
                    res.push(obj2)
                }
                else{
                    let obj = {
                        ...item,
                        ssa_seq:seq
                    }
                    seq++
                    res.push(obj)
                }
                return res
            },[])
            this.$http.post(this.$api.selfApp.adjustStarSelfAppSeq, {
                starSelfAppList: resArr
            }).then(() => {
                this.dragConfig = {
                    starAppId:null, 
                    endAppId:{}, 
                    pos:null
                }
                this.cstAppConfig.starApps = resArr
            })
        },
        delItem(item){
            if(this.cstAppConfig.deletingItemId===item.sapp_id){
                return 
            }
            this.cstAppConfig.deletingItemId=item.sapp_id;
            this.$http.post(this.$api.selfApp.delStarSelfApp, {
                ssa_id: item.ssa_id
            }).then(() => {
                this.openDragFlag()
            }).finally(()=>{
                this.cstAppConfig.deletingItemId=null;
            })
        },
        selectApp(item){
            if(this.cstAppConfig.starApps.some(xitem=>{
                return xitem.sapp_id==item.sapp_id
            })){
                this.$message.warning('该应用已经是星标应用')
                return
            }
            this.$http.post(this.$api.selfApp.addStarSelfApp, {
                sapp_id: item.sapp_id
            }).then(() => {
                this.appSelector.flag = false
                this.openDragFlag()
            })
        },
        openDialogFunc5(){
            this.isSelfBuildAppJump=true
        },
        closeDialogInfo5(){
            this.isSelfBuildAppJump=false
        },
        openNewWindow(){ 
            this.isSelfBuildAppJump=false
            this.$nextTick(()=>{
                const { href } =this.$router.resolve({
                    path:'/selfBuildApp/outSelfBuildLogin',
                    query:{
                        sapp_id:this.id,
                        sapp_key:this.key,
                        sapp_index:this.index,
                        sapp_name:this.name,
                    }
                })
                this.isSelfBuildAppJump=false
                window.open(href,'_blank')
            })
        },
        // openDialogFunc6(){
        //     const data={
        //         sapp_id:this.id
        //     }
        //     this.$http.post(this.$api.selfBuildApp.queryMySelfAppEmpAuth,data).then((res)=>{
        //         if(res.payload){
        //             Object.assign(this.appAuth,res.payload)
        //             // this.isSelfBuildAppJump=false
        //             if(this.appAuth.phone==false||this.appAuth.empInfo==false){
        //                 this.isSelfBuildAppInit=true
        //             }else{
        //                 this.openNewWindow()
        //             }                    
        //         }
        //     })
        // },
        // saveDialogInfo6(){
        //     this.appAuth.phone=true;//直接全部通过
        //     this.appAuth.empInfo=true;
        //     const data={
        //         sapp_id:this.id,
        //         sapp_ea_auth:JSON.stringify(this.appAuth)
        //     }
        //     this.$http.post(this.$api.selfBuildApp.setMySelfAppEmpAuth,data).then(()=>{
        //         if(this.appAuth.phone==false&&this.appAuth.empInfo==false){//这些暂时没用了
        //             this.$message.warning("请配置权限")
        //             this.isSelfBuildAppInit=true;
        //         }else if(this.appAuth.phone==true&&this.appAuth.empInfo==false){
        //             this.$message.warning("请配置个人信息权限")
        //             this.isSelfBuildAppInit=true;
        //         }else if(this.appAuth.phone==false&&this.appAuth.empInfo==true){
        //             this.$message.warning("请配置手机权限")
        //             this.isSelfBuildAppInit=true;
        //         }else{
        //             this.$message.success("权限设置成功")
        //             this.isSelfBuildAppInit=false;//关闭
        //             this.openNewWindow()
        //         }                
        //     })
        // },
        // closeDialogInfo6(){
        //     this.isSelfBuildAppInit=false;
        // },
        // openNewWindow(){
        //     const info={
        //         appKey:this.key
        //     }
        //     this.$http.post(this.$api.openapi.getAuthorize, info).then((retu) => {
        //         if (retu.payload?.code && this.index) {
        //             const targetUrl = `${this.index}?code=${retu.payload.code}`;//这里无法阻止注入
        //             if (this.isValidUrl(targetUrl)) {
        //                 window.open(targetUrl,'_blank')
        //             } else {
        //                 this.$message.error('路径无效，无法跳转')//这里的逻辑十分奇怪，我跟希望是进入对话框之前就实现处理
        //             }
        //         }
        //     })
        // },
    },
    // beforeRouteLeave(to, from, next) {
    //     this.isSelfBuildAppJump = false; // 离开路由时强制关闭弹窗
    //     next();
    // },
    // beforeUnmount() {
    //     this.isSelfBuildAppJump = false; // 组件销毁前重置状态
    // }
  }
  </script>
  
<style lang="scss" scoped>
  .topAppNav{
    
  }
  .topAppNav_clickDom_box{
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #303033;
    cursor: pointer;
    padding: 8px;
    white-space: nowrap;
    i{
        margin-left: 8px;
        color: #ffffff;
    }
  }
  .defalutIndex_content_appHeaderBox{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 46px;
        padding: 0 16px;
        border-bottom: 1px solid #E1E1E5;
        .defalutIndex_content_appHeader_text{
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 16px;
            color:#303033;
            img{
                margin-right: 9px;
            }
        }
        .defalutIndex_content_appHeader_op{
            display: flex;
            align-items: center;
            i{
                margin-right: 4px;
                font-size: 14px;
            }
            .defalutIndex_content_appHeader_add{
                cursor: pointer;
            }
        }
        .defalutIndex_content_appHeader_input{
            width: 180px;
            background: #F0F0F5;
            border-radius: 4px;
            height: 34px;
            display: flex;
            align-items: center;
            padding-left: 15px;
            margin-right: 16px;
            :deep(.el-input__wrapper){
                background: transparent;
                box-shadow: none;
                outline: none;
                height: 34px;
                line-height: 34px;
                padding-left: 5px;
            }
        }
    }
  .defalutIndex_content_appList{
    height: 460px;
    overflow-y: scroll;
    padding-top:15px;
    .defalutIndex_content_appGroup{
        padding:0 15px;
        padding-right: 7px;
        .defalutIndex_content_appGroup_title{
            font-size: 14px;
            font-weight: 200;
            padding-left: 5px;
            padding-top: 0px;
        }
        .defalutIndex_content_appGroup_item{
            margin-bottom:30px;
            cursor: pointer;
        }
        .defalutIndex_content_appGroup_items{
            display: flex;
            flex-wrap: wrap;
            margin-top: 20px;
            gap: 0px;
            .defalutIndex_content_appGroup_itemBox{
                display: flex;
                justify-content: center;
            }
            .defalutIndex_content_appGroup_itemIcon{
                width: 32px;
                height: 32px;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                i{
                    font-size: 16px;
                    color: #fff;
                }
            }
            .defalutIndex_content_appGroup_itemNmae{
                text-align: center;
                width: 90px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                margin-top: 10px;
                color: #303033;
                font-size: 14px;
            }
        }
    }
}
.defalutIndex_empty{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0;
    color: #A1A2AB;
}
.appSelect_empty{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0;
    color: #A1A2AB;
}
.appOp_list {
  padding: 5px 0;
  .appOp_item {
    display: flex;
    align-items: center;
    height: 50px;
    cursor: pointer;
    &:hover {
      background: #f2f3f5;
    }
    >img {
      margin-left: 18px;
      margin-right: 14px;
    }
  }
}
:deep(.el-dialog__body) {
    padding: 0;
}
:deep(.el-dialog__header) {
    border-bottom: 1px solid #dee0e3;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-right: 0;
}
:deep(.el-dialog__title) {
    font-size: 16px;
    color: #575757;
}
:deep(.el-dialog__headerbtn) {
    top: 0;
    width: 45px;
}

.dlg_main {
  max-height: 60vh;
  padding: 20px;
  padding-right: 12px;
  box-sizing: border-box;
  overflow-y: scroll;
  padding-bottom: 0;
  .dlg_item {
    margin-bottom: 20px;
    .dlg_item_title {
      margin-bottom: 12px;
    }
  }
  .createApp_item {
    display: flex;
    align-items: center;
    .el-select {
      width: 100%;
    }
    .defalutIndex_content_appHeader_add{
        white-space: nowrap;
        color: var(--mainColor);
        margin-left: 8px;
        font-weight: normal;
        cursor: pointer;
    }
  }
  .importApp_item {
    margin-bottom: 15px;
    .el-select {
      width: 100%;
    }
    .importNewBool_uploadbox{
      width:250px;
      height:40px;
      border:1px solid #DCDFE6;
      border-radius: 4px;
      text-align: start;
      line-height: 40px;
      padding: 0 15px;
      color: #b1b5bd;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .color-box {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .color-item-box {
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      border-radius: 3px;
      transition: all ease 0.2s;
      &:hover {
        opacity: 0.75;
      }
      .chose-color {
        color: #fff;
      }
    }
  }
  .icon-box {
    overflow-y: auto;
    margin-top: 10px;
    margin-bottom: 20px;
    width: 100%;
    height: 210px;
    position: relative;
    box-sizing: border-box;
    padding: 12px 5px 12px 12px;
    background-color: #f2f3f5;
    border-radius: 4px;
    border: solid 1px #dee0e3;
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
    }
    .icon-scroll-box {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
    }
    .icon-item-box {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      padding: 9px;
      border-radius: 3px;
      &:hover {
        background: rgb(211, 207, 207);
      }
      .color-icon {
        color: #a3a8af;
      }
      i {
        font-size: 18px;
      }
    }
    .activ-icon {
      .color-icon {
        color: #fff;
      }
    }
    .group-icon-select {
      background: rgb(211, 207, 207);
      i {
        color: #ffffff;
      }
    }
  }
  .app-icon-box {
    height: 220px;
  }
  .mb15 {
    margin-bottom: 15px;
  }
}
.cstAppContent_box{
    padding-bottom:15px;
    .cstAppContent_item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #F5F7FC;
        border: 1px solid #e1e1e5;
        padding:10px 15px;
        padding-left:10px;
        border-radius: 4px;
        margin-bottom: 10px;
        cursor: pointer;
        position: relative;
        .cstAppContent_header{
            display: flex;
            align-items: center;
            color: #A1A2AB;
            pointer-events: none;
            .cstAppContent_icon{
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 12px;
                color:#fff;
                border-radius: 4px;
                margin-left: 16px;                
                font-size: 18px;
            }
            .cstAppContent_name{
                color: #303033;
            }
        }
    }
    .cstAppContent_add{
        display: flex;
        color: #909099;
        align-items: center;
        cursor: pointer;
        padding-bottom: 15px;
        position: relative;
        i{
            margin-right: 8px;
        }
    }
    .dragItem_top{
        &::before{
            content: '';
            display: block;
            width:100%;
            height: 2px;
            background-color: var(--mainColor);
            position: absolute;
            left: 0;
            top: -7px;
        }
    }
    .dragItem_bottom{
        &::after{
            content: '';
            display: block;
            width:100%;
            height: 2px;
            background-color: var(--mainColor);
            position: absolute;
            left: 0;
            bottom: -7px;
        }
    }
}
.appSelect_input{
    margin-bottom: 15px;
}
.appSelect_box{
    height: 400px;
    overflow: auto;
    border: 1px solid #dee0e3;
    border-radius:4px;
    margin-bottom: 15px;
    padding:12px 0;
    .appSelect_item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:12px 15px;
        border-radius: 4px;
        cursor: pointer;
        position: relative;
        &:hover{
            background-color:#f2f3f5;
        }
        .appSelect_header{
            display: flex;
            align-items: center;
            color: #A1A2AB;
            pointer-events: none;
            .appSelect_icon{
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 12px;
                color:#fff;
                border-radius: 4px;               
                font-size: 18px;
            }
            .appSelect_name{
                color: #303033;
            }
        }
    }
}
    .selfBuildApp_middle_head1{
        padding:0px 25px;
        margin:20px 0px 0px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: #616161;
        font-size:18px;
    }
    .selfBuildApp_after_appAuth{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding:10px 30px;
        gap:15px;
        .selfBuildApp_auth{
            display: flex;
            flex-direction: row;
            justify-content:space-between;
            margin-top:15px;
            .selfBuildApp_icon{
                display: flex;
                justify-content: center;
                margin-right: 10px;
                width: 40px;
                height: 40px;
                border: 1px solid;
                border-radius: 20px;
            }
            span{
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                font-size:16px;
                line-height: 40px;
                text-align: center;
            }
        }
    }
    .dialog-footer{
        display: flex;
        justify-content: space-between;
        gap:20px;
        padding:10px 10px 0px;
        :deep(.el-button){
            width: 100%;
        }
    }
    .selfBuildApp_middle_head{
        padding:0px 25px;
        margin:20px 0px 0px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: #616161;
        font-size:15px;
    }
    :deep(.el-drawer){
        left: 50%;
        transform: translateX(-50%); // 修正自身宽度的一半
    }
    :deep(.el-drawer__header){
        padding-top:20px;
        margin-bottom:0px;
        .el-drawer__title{
            font-size:20px;
            line-height:20px;
        }
    }
    :deep(.el-drawer__footer){
        padding:10px 10px 20px;
    }
  </style>
  <style>
    .topAppNav_popper{
        padding: 0!important;
    }
</style>
  